// extracted by mini-css-extract-plugin
export var errorIcon = "_pb-1";
export var nameLogo = "_pb-0";